import { HttpClient }               from '@angular/common/http';
import { Injectable }               from '@angular/core';
import { AbstractApiService }       from '@app/core/http/abstract-api.service';
import { TransitionService }        from '@app/core/http/transition.service';
import { LoggerService }            from '@app/shared/services/logger.service';
import { RequestCompleteListState } from '@core/interfaces/api.interface';
import { SanitizerService }         from '@http/sanitizer.service';
import { ResourceLock }             from '@models/resource-lock.model';
import { ModelTypeEnum }            from '@models/transition.model';
import {
	GetBusinessPremisesResourceLocksRequestParams,
	ResourceLockApiClient,
	ResourceLockDTO
}                                   from '@openApiGenerated/management-api';
import { Observable }               from 'rxjs';


@Injectable( {
	providedIn: 'root'
} )
export class ResourceLocksApiService extends AbstractApiService {

	constructor(
		protected http: HttpClient,
		protected logger: LoggerService,
		private readonly resourceLocksApiClient: ResourceLockApiClient,
		private readonly sanitize: SanitizerService,
		private readonly transition: TransitionService
	) {
		super();
		this.http = http;
	}

	private sanitizeApiResponse( entity: ResourceLock, context = this ): void {
		if ( entity instanceof ResourceLock ) {
			entity.createdDate = context.sanitize.date<Date>( entity.createdDate, ModelTypeEnum.TMO, Date );
		}
	}


	public getResourceLocksByBusinessPremisesId( businessPremisesId: string, throwError = false ): Observable<RequestCompleteListState<ResourceLock>> {
		this.logger.trace( 'pre-getResourceLock call' );

		const requestParam: GetBusinessPremisesResourceLocksRequestParams = { businessPremisesId };

		const req$ = this.resourceLocksApiClient.getBusinessPremisesResourceLocks( requestParam );
		return this.transition.handleListRequestResponse<ResourceLockDTO, ResourceLock>(
			req$,
			ResourceLock,
			this,
			this.sanitizeApiResponse,
			null,
			null,
			throwError
		);
	}
}
